import { render } from "./DownloadAppInstructions.vue?vue&type=template&id=bd491056&scoped=true"
import script from "./DownloadAppInstructions.vue?vue&type=script&lang=js"
export * from "./DownloadAppInstructions.vue?vue&type=script&lang=js"

import "./DownloadAppInstructions.vue?vue&type=style&index=0&id=bd491056&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd491056"]])

export default __exports__